(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-service-outlets');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const mapContainer = container?.querySelector('.js-service-outlets-map');
  const listContainer = container?.querySelector('.js-service-outlets-list');

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.serviceOutletsSection = {
    _currentlyHighlightedOutlet: undefined,

    getOutlets: function() {
      return [...container.querySelectorAll('.js-stoloccard')];
    },

    highlight: function(outlet) {
      if (this._currentlyHighlightedOutlet) this.unhighlight(this._currentlyHighlightedOutlet);
      this._currentlyHighlightedOutlet = outlet;

      const id = outlet?.id;
      if (!id) return;

      // Get the actual marker image (not the clickable transparent overlay).
      const img = mapContainer.querySelector(`img[src$='id=${id}']`);
      if (img) {
        img.parentElement.classList.add('service-outlets__marker');
        img.parentElement.classList.add('service-outlets__marker--active');
      }

      outlet.parentElement.classList.add('service-outlets__card--active');
    },

    unhighlight: function(outlet) {
      const id = outlet?.id;
      if (!id) return;

      const img = mapContainer.querySelector(`img[src$='id=${id}']`);
      if (img) img.parentElement.classList.remove('service-outlets__marker--active');

      outlet.parentElement.classList.remove('service-outlets__card--active');
    },

    scrollTo: function (outlet) {
      let card = outlet;
      while (card && !card.classList.contains('horizontal-list-card')) card = card.parentElement;
      if (!card) return;

      listContainer.querySelector('.horizontal-list-row').scrollTo({
        left: card.offsetLeft + card.offsetWidth/2 - listContainer.offsetWidth/2,
        behavior: 'smooth'
      });
    },

  }


  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_serviceOutletsMap = {
    attach: function attach(context) {

      $(once('promutuelServiceOutletsMap', container, context)).each(async function() {
        // Don't start until the Google Maps API is available.
        await Promutuel.gmaps.initialize();

        const gmap = new google.maps.Map(
          mapContainer,
          Promutuel.gmaps.getDefaultMapOptions(),
        );

        const outlets = Promutuel.serviceOutletsSection.getOutlets();
        // List of markers, to manage automatic center/zoom.
        const markers = [];

        outlets.forEach(outlet => {
          const position = {
            lat: parseFloat(outlet.dataset.latitude),
            lng: parseFloat(outlet.dataset.longitude),
          };

          const marker = new google.maps.Marker({
            position,
            title: outlet.querySelector('[data-field=title]').textContent.trim(),
            icon: {
              url: `${drupalSettings.path.baseUrl}${drupalSettings.path.themeUrl}/images/phylactere/${drupalSettings.path.currentLanguage}/phylactere.svg#id=${outlet.id}`,
              scaledSize: new google.maps.Size(48, 52),
              anchor: new google.maps.Point(0, 52),
            },
            id: outlet.id,
            map: gmap, // Attach the marker to the map immediately.
          });

          markers.push(marker);

          // Click handler on the marker.
          marker.addListener('click', event => {
            Promutuel.serviceOutletsSection.highlight(outlet);
            Promutuel.serviceOutletsSection.scrollTo(outlet);
          });
          // Click handler on the card in the list.
          outlet.addEventListener('click', event => {
            Promutuel.serviceOutletsSection.highlight(outlet);
          });
        });

        Promutuel.gmaps.fitMarkersIntoView(markers);

        // Global click handler to unselect (registered on capture only).
        document.addEventListener('click', event => {
          Promutuel.serviceOutletsSection.highlight(null);
        }, true);
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
